import API from "../../../services/api";

export const getInventorySettings = async (query = {}) => {
  const params = new URLSearchParams(query).toString();
  const res = await API.get(`/inventory-settings?${params}`);
  return res;
};

export const createInventorySetting = async (data) => {
  const res = await API.post("/inventory-settings", data);
  return res;
};

export const updateInventorySetting = async (id, data) => {
  const res = await API.patch(`/inventory-settings/${id}`, data);
  return res;
};

export const deleteInventorySetting = async (id, query = {}) => {
  const params = new URLSearchParams(query).toString();
  const res = await API.delete(`/inventory-settings/${id}?${params}`);
  return res;
};

// ─── Purchase services ──────────────────────────────────────────────────────
export const getPurchases = async (query = {}) => {
  const params = new URLSearchParams(query).toString();
  const res = await API.get(`/inventory/purchases?${params}`);
  return res;
};

export const deletePurchase = async (id) => {
  const res = await API.delete(`/inventory/purchases/${id}`);
  return res;
};

// ─── Sale services ──────────────────────────────────────────────────────────
export const getSales = async (query = {}) => {
  const params = new URLSearchParams(query).toString();
  const res = await API.get(`/inventory/sales?${params}`);
  return res;
};

export const deleteSale = async (id) => {
  const res = await API.delete(`/inventory/sales/${id}`);
  return res;
};

// ─── Purchase Return services ────────────────────────────────────────────────
export const getPurchaseReturns = async () => {
  const res = await API.get('/inventory/purchase-returns');
  return res;
};

export const deletePurchaseReturn = async (id) => {
  const res = await API.delete(`/inventory/purchase-returns/${id}`);
  return res;
};

// ─── Sale Return services ────────────────────────────────────────────────────
export const getSaleReturns = async () => {
  const res = await API.get('/inventory/sale-returns');
  return res;
};

export const deleteSaleReturn = async (id) => {
  const res = await API.delete(`/inventory/sale-returns/${id}`);
  return res;
};

// ─── Vendor Balance services ─────────────────────────────────────────────────
export const getVendorBalances = async (query = {}) => {
  const params = new URLSearchParams(query).toString();
  const res = await API.get(`/inventory/vendor-balance?${params}`);
  return res;
};

export const createVendorBalance = async (data) => {
  const res = await API.post('/inventory/vendor-balance', data);
  return res;
};

export const deleteVendorBalance = async (id) => {
  const res = await API.delete(`/inventory/vendor-balance/${id}`);
  return res;
};

// ─── Challan services ────────────────────────────────────────────────────────
export const getChallans = async () => {
  const res = await API.get('/inventory/challans');
  return res;
};

export const deleteChallan = async (id) => {
  const res = await API.delete(`/inventory/challans/${id}`);
  return res;
};

// ─── Shipping services ───────────────────────────────────────────────────────
export const getShipments = async () => {
  const res = await API.get('/inventory/shipping');
  return res;
};

export const deleteShipment = async (id) => {
  const res = await API.delete(`/inventory/shipping/${id}`);
  return res;
};

